module.exports = __webpack_public_path__ + "img/notandi.5ee56d38.svg";